import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\(generated)\\diwali-delights-sparkling-customer-experiences\\Body.jsx");
